import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHeart, FiMusic } = FiIcons;

const Footer = () => {
  return (
    <footer className="py-8 px-4 mt-16">
      <div className="container mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="flex items-center justify-center gap-2 text-gray-400"
        >
          <span>Made with</span>
          <SafeIcon icon={FiHeart} className="w-4 h-4 text-red-400" />
          <span>for music theory enthusiasts</span>
          <SafeIcon icon={FiMusic} className="w-4 h-4 text-purple-400" />
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-4 space-y-2"
        >
          <p className="text-sm text-gray-500">
            Perfect for musicians, composers, and music students
          </p>
          <p className="text-xs text-gray-600">
            Learn • Practice • Master
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;